<app-feature-list-container
  *ngIf="heatingServiceTimeBased"
  title="{{ '+INSTALLATIONS.INSTALLATION.SERVICE_INTERVAL_RESET.TITLE' | translate }}"
>
  <div class="feature-grid-container" viFeatureGrid viBorderBottom>
    <app-feature-list-item
      *ngIf="heatingServiceTimeBased.properties?.lastService"
      data-at-last-service-date
      label="{{
        '+INSTALLATIONS.INSTALLATION.SERVICE_INTERVAL_RESET.LAST_SERVICE_DATE' | translate
      }}"
      [value]="heatingServiceTimeBased | value2: featurePropertyKey.lastService | date: 'short'"
      [attr.data-feature]="heatingServiceTimeBased.feature"
    >
    </app-feature-list-item>

    <app-feature-list-item
      *ngIf="heatingServiceTimeBased.properties?.nextService"
      data-at-next-service-date
      label="{{
        '+INSTALLATIONS.INSTALLATION.SERVICE_INTERVAL_RESET.NEXT_SERVICE_DATE' | translate
      }}"
      [value]="heatingServiceTimeBased | value2: featurePropertyKey.nextService | date: 'short'"
      [attr.data-feature]="heatingServiceTimeBased.feature"
    >
    </app-feature-list-item>
  </div>
  <div
    *ngIf="heatingServiceTimeBased | executable: featureCommands.confirmService"
    class="reset-button-wrapper"
  >
    <button
      gtm="onClick"
      gtmAction="Reset service date time"
      gtmCategory="system"
      mat-raised-button
      color="primary"
      [viConfirm]="{
        title: '+INSTALLATIONS.INSTALLATION.SERVICE_INTERVAL_RESET.CONFIRM.TITLE' | translate,
        content: '+INSTALLATIONS.INSTALLATION.SERVICE_INTERVAL_RESET.CONFIRM.CONTENT' | translate,
        cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
        confirmBtn: 'GENERAL.BUTTON.RESET' | translate
      }"
      (confirm)="resetServiceDate()"
      (cancel)="cancelResetServiceDateConfirmation()"
    >
      {{ 'GENERAL.BUTTON.RESET' | translate }}
    </button>
  </div>
</app-feature-list-container>
